<script>
    export let text = "";
    export let onClickFunction = () => {
    };
</script>

<div on:click={onClickFunction}>
    {text}
</div>

<style>
    div {
        border: solid black 2px;
        padding: 16px;
        width: fit-content;
        box-shadow: 2px 2px;
        cursor: pointer;
        user-select: none;
    }

    div:active {
        transform: translate(2px, 2px);
        box-shadow: 0 0;
    }
</style>
